import React, { useContext, useState } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Confirm, Container, Tab, Grid, GridColumn, Form, Input, Dropdown, Popup } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import BogStore from '../../../app/stores/bogStore';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';

const BogListByDate: React.FC = () => {
  const bogStore = useContext(BogStore);
  const {bogsByDate, searchDate, selectBogTitle, bogSearchList, bogsCSV, submitting, target} = bogStore;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [required, setRequired] = useState(false);

  const projectList  = bogSearchList.map((item) => {
    return item["projectType"];
  });
  const projects = projectList.filter(function(item, pos) {
    return projectList.indexOf(item) == pos;
  })
  projects.unshift('ALL');

  const companyList  = bogSearchList.map((item) => {
    return item["company"];
  });
  const companys = companyList.filter(function(item, pos) {
    return companyList.indexOf(item) == pos;
  })
  companys.unshift('ALL');

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  return (
    <Container fluid>
      <br/>
      <Grid>
        <GridColumn width='4'>
        <Form>
          <Form.Field inline>
           <label>From: </label>
           <Input 
             required
             onChange={(e, {value}) => {setStartDate(value);setRequired(false)}}
             name="startDate"
             placeholder="Start Date"
             value={startDate}
             type="date"
           />
           {(required) && <p style={{color: 'red'}}>please input start date</p>}
          </Form.Field>
        </Form>
        </GridColumn>
        <GridColumn width='4'>
        <Form>
          <Form.Field inline>
           <label>To: </label>
           <Input 
             onChange={(e, {value}) => setEndDate(value)}
             name="endDate"
             placeholder="End Date"
             value={endDate}
             type="date"
           />
           <p>leave blank to display all since start date</p>
          </Form.Field>
        </Form>
        </GridColumn>
        <GridColumn width='3'>
        <Button
          floated='left'
          size='small'
          positive
          content='Submit'
          onClick={() => {(startDate !== "") ? searchDate(startDate, endDate) : setRequired(true)}}
        />
        </GridColumn>
      </Grid>
      <br/>
      <CSVLink data={bogsCSV}  filename={"boglist.csv"}>
        <Popup content='Download as CSV' trigger={<Button icon='download' floated='left' />} />
      </CSVLink>
      <br/>
      <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        <Table.HeaderCell>Technician</Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Project Type'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {projects.map((project) => 
           <Dropdown.Item
             name='projectType'
             onClick={(e, { name }) =>
             selectBogTitle(name, project)
            }
           >
             {project}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Company'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {companys.map((company) => 
           <Dropdown.Item
             name='company'
             onClick={(e, { name }) =>
             selectBogTitle(name, company)
            }
           >
             {company}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>Site ID</Table.HeaderCell>
        <Table.HeaderCell>Site Name</Table.HeaderCell>
        <Table.HeaderCell>State</Table.HeaderCell>
        <Table.HeaderCell>Ring ID</Table.HeaderCell>
        <Table.HeaderCell>Work Type</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {bogsByDate.map(bog => (     
      <Table.Row>
        <Table.Cell>
         <strong >{convertDate(bog.date)}</strong>
         <p>{getDayOfWeek(bog.date)}</p>
        </Table.Cell>
        <Table.Cell>{bog.technician}</Table.Cell>       
        <Table.Cell>{bog.projectType}</Table.Cell>
        <Table.Cell>{bog.company}</Table.Cell>
        <Table.Cell>{bog.siteId}</Table.Cell>
        <Table.Cell>{bog.siteName}</Table.Cell>
        <Table.Cell>{bog.state}</Table.Cell>
        <Table.Cell>{bog.ringId}</Table.Cell>
        <Table.Cell>{bog.type}</Table.Cell>
        <Table.Cell>{bog.status}</Table.Cell>       
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
    </Container>
  );
};

export default observer(BogListByDate);
